import Vue from 'vue'
import VueRouter from 'vue-router'
import Topic from '@/pages/topic/Topic.vue'
import Detail from '@/pages/detail/Detail.vue'
import newDetail from '@/pages/newDetail/newDetail.vue'
import newTopic from '@/pages/newTopic/Topic.vue'
import tagList from '@/pages/tagList/tagList.vue'
import map from '@/pages/map/map.vue'
import lottery from '@/pages/lottery/lottery.vue'

var routes = [
    {
      path: '/topic/:tag_id',
      name: 'topic',
      component: Topic
    },
    {
      path: '/detail/:po_id',
      name: 'detail',
      component: Detail
    },
    {
      path: '/newDetail/:po_id/:from_admin?',
      name: 'newDetail',
      component: newDetail
    },
    {
      path: '/newTopic/:tag_id',
      name: 'newTopic',
      component: newTopic
    },
    {
      path: '/tag-list/:tid',
      name: 'tagList',
      component: tagList
    },
    {
      path: '/map/:log/:lat',
      name: 'map',
      component: map
    },
    {
      path: '/lottery/:po_id',
      name: 'lottery',
      component: lottery
    }
]

const router = new VueRouter({
  // mode: 'history', //html5模式 去掉锚点
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes // short for `routes: routes`
})

Vue.use(VueRouter)

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js